// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"burgercontrol__BuildControl__3vXzd","Label":"burgercontrol__Label__2vkR-","Less":"burgercontrol__Less__2pstn","More":"burgercontrol__More__1_fbI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burgercontrols/Burgercontrol/burgercontrol.css
// module id = 142
// module chunks = 3